import { render, staticRenderFns } from "./BookingPrecheckin.vue?vue&type=template&id=63470474"
import script from "./BookingPrecheckin.vue?vue&type=script&lang=js"
export * from "./BookingPrecheckin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports